import { MdFileDownload } from 'react-icons/md';
import styles from './styles.module.scss';

type DownloadButtonProps = {
  disabled?: boolean;
  onClick?: () => void;
};

export const DownloadButton = ({ disabled = false, onClick }: DownloadButtonProps) => {
  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <button
      type="button"
      className={`${styles.container} ${disabled ? styles.disabled : ''}`}
      onClick={handleClick}
      disabled={disabled}
    >
      <div className={styles.iconWrapper}>
        <MdFileDownload size={20} className={styles.icon} />
      </div>
    </button>
  );
};

